import { render, staticRenderFns } from "./InputHTML.vue?vue&type=template&id=52ac1f16&"
import script from "./InputHTML.vue?vue&type=script&lang=js&"
export * from "./InputHTML.vue?vue&type=script&lang=js&"
import style0 from "./InputHTML.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports